import { ApiSavedSearchUnsaved } from 'api/savedSearch/types/ApiSavedSearch';
import { del, postJson } from 'utils/http';

export function apiCreateSavedSearch({
  text,
  filters,
  location,
  index,
  radius,
}: ApiSavedSearchUnsaved) {
  return postJson('/data/saved-searches', {
    text,
    filters,
    radius,
    location,
    index,
  });
}

export function apiDeleteSavedSearch(searchId: string) {
  return del(`/data/saved-searches/${searchId}`);
}
